module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_10.27892614.pdf";